import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';

import {
  GlobalErrorHandlerService,
  GlobalsService,
} from '@shared/services/globals.service';
import { routes } from './app.routes';
import { RequestInterceptorService } from './core';
import { MiscellaneousService } from './shared/services/apis/miscellaneous.service';

export function initializeApp(
  globals: GlobalsService,
  miscellaneousService: MiscellaneousService
) {
  return async () => {
    try {
      globals.showsplash = true;
      setTimeout(async () => {
        globals.showsplash = false;
        await miscellaneousService.getProductList();
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [GlobalsService],
      multi: true,
    },
    importProvidersFrom(BrowserAnimationsModule),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
  ],
};
